<template>
  <v-app id="inspire" class="eservice_wrap none_layout">
    <v-content>
      <router-view :key="key"/>
    </v-content>
    <Dialog />
    <DialogTimeOut />
    <div class="loader" v-show="isShowLoading">
      <div class="loader_cont">
        <div class="lds-roller">
          <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import eventBus from '@/utils/eventBus'
import store from '@/store'
import Dialog from '@/components/layout/Dialog'
import DialogTimeOut from '@/components/layout/DialogTimeOut'
import en from 'vee-validate/dist/locale/en'
import ar from 'vee-validate/dist/locale/ar'

export default {
  name: 'CommonRouterSection',
  components: {
    Dialog,
    DialogTimeOut
  },
  data () {
    return {
      isShowLoading: false
    }
  },
  watch: {
    storeLoadingCount: function(val) {
      if (val <= 0) {
        store.dispatch('SetInitRequestApi')
        setTimeout(() => {
          this.isShowLoading = false
        }, 300)
      } else {
        if (!this.isShowLoading) {
          this.isShowLoading = true
        }
      }
    }
  },
  computed: {
    key () {
      return this.$route.fullPath
    },
    storeLoadingState() {
      return store.state.api.loading.isVisible
    },
    storeLoadingCount() {
      return store.state.api.loading.requestCount
    }
  },
  created() {
    store.dispatch('SetInitRequestApi')
  },
  mounted() {
    eventBus.$off('SHOW_ERROR_SNACKBAR')
    eventBus.$on('SHOW_ERROR_SNACKBAR', (res) => {
      let option = {
        text: (this.$i18n.locale === 'en') ? res.res_msg_en : res.res_msg_ar
      }
      eventBus.$emit('SHOW_SNACKBAR', option)

      // token 오류 (401011)
      // token 만료 (401012)
      // token 오류 (401013)
      // token 오류 (401014)
      // Not allowed ip address (401015)
      if (res.res_code === '401011' || res.res_code === '401013' || res.res_code === '401014') {
        store.dispatch('SetInitToken')
        store.dispatch('SetInitAuthHeader')
        // 로그인 페이지로 이동
        this.$router.push('/signin')
      }
    })
    this.fnInit()
  },
  methods: {
    fnInit() {
      if (store.state.api.language === 'en') {
        this.$vuetify.rtl = false
        this.$i18n.locale = 'en'
        this.$vuetify.lang.current = 'en'
        this.$validator.localize('en', en)
      } else if (store.state.api.language === 'ar') {
        this.$vuetify.rtl = true
        this.$i18n.locale = 'ar'
        this.$vuetify.lang.current = 'ar'
        this.$validator.localize('ar', ar)
      }
    },
  }
}
</script>

<style lang="less" scoped>

</style>